//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.BundleItem
import com.tixforgigs.apax.models.FloorPlanData
import com.tixforgigs.apax.models.ItemType
import com.tixforgigs.apax.models.PersonalizationData
import com.tixforgigs.apax.models.PriceInfo

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The shopping cart item model.
* 
* @param cartItemId The item id
* @param eventId The event id
* @param eventTitle The localized title of the event
* @param isPersonalized Defines if the product is personalized
* @param itemType 
* @param maxOrderCount The max amount of products a user can order
* @param priceInfo 
* @param productId The product id
* @param productTitle The localized title of the product
* @param quantity The quantity of this product
* @param bundleItems The bundled items
* @param floorPlanData The optional floorplan items
* @param personalizationData The personalization config
* @param resaleId The resale id
*/
@Serializable

data class ShoppingCartItem (


      /* The item id */
    @SerialName(value = "cartItemId") @Required val cartItemId: kotlin.uuid.Uuid,


      /* The event id */
    @SerialName(value = "eventId") @Required val eventId: kotlin.Int,


      /* The localized title of the event */
    @SerialName(value = "eventTitle") @Required val eventTitle: kotlin.String,


      /* Defines if the product is personalized */
    @SerialName(value = "isPersonalized") @Required val isPersonalized: kotlin.Boolean,


      @SerialName(value = "itemType") @Required val itemType: ItemType?,


      /* The max amount of products a user can order */
    @SerialName(value = "maxOrderCount") @Required val maxOrderCount: kotlin.Int,


      @SerialName(value = "priceInfo") @Required val priceInfo: PriceInfo,


      /* The product id */
    @SerialName(value = "productId") @Required val productId: kotlin.Int,


      /* The localized title of the product */
    @SerialName(value = "productTitle") @Required val productTitle: kotlin.String,


      /* The quantity of this product */
    @SerialName(value = "quantity") @Required val quantity: kotlin.Int = 0,


      /* The bundled items */
    @SerialName(value = "bundleItems") val bundleItems: kotlin.collections.List<BundleItem>? = null,


      /* The optional floorplan items */
    @SerialName(value = "floorPlanData") val floorPlanData: kotlin.collections.List<FloorPlanData>? = null,


      /* The personalization config */
    @SerialName(value = "personalizationData") val personalizationData: kotlin.collections.List<PersonalizationData>? = null,


      /* The resale id */
    @SerialName(value = "resaleId") val resaleId: kotlin.Int? = null


) {




  }

